import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FullscreenRef } from '../../../fullscreen/fullscreen-ref';

@Component({
    selector: 'lib-unsaved-changes-question',
    templateUrl: './unsaved-changes-question.component.html',
    styleUrls: ['./unsaved-changes-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UnsavedChangesQuestionComponent implements OnInit {
  constructor(private popoverRef: FullscreenRef<any, { response: number }>) {}

  ngOnInit(): void {}

  close(response: number) {
    this.popoverRef.close({ response });
  }
}
